<template>
  <AcaSchoolPageSkeleton />
</template>

<script lang="ts" setup>
import AcaSchoolPageSkeleton from '~/components/aca/AcaSchoolPageSkeleton.vue'
</script>
